import { useState } from "react";
import OffRate from "./OffRate";
import { useTranslation } from "react-i18next";
import { useSettings } from "context/SettingsContext";
import { useAuth } from "context/AuthContext";

const ToolBarRate = () => {
 
    const { t } = useTranslation(['Rate']);
    const { auth } = useAuth();
    const { localSettings } = useSettings();
    const [ showRate, setShowRate ] = useState(false);

    const currentRate = Number(localSettings?.RATE?.current ?? 0);
    const isUahMode = currentRate === 1;
    const dynamics = localSettings?.RATE?.dynamics || 0;

    return (
        <>
        <OffRate
            show={showRate}
            setShow={setShowRate}/>

        <div className="pc-h-item">
            <span className="pc-head-link ms-0 cursor-pointer flex-column align-items-start"
                style={{width:'fit-content'}}
                onClick={()=>{
                    if (auth?.user?.access?.role == 'manager')  setShowRate(true)
                }}>
                
                <div className="px-md-2" 
                    style={{zIndex:'999'}}>

                    <div>
                    <span className="fs-10 text-muted font-bold d-none d-md-inline-block">
                        {isUahMode ? t('titleUahMode') : t('titleRate')}
                    </span>
                    <span className="fs-10 text-muted font-bold d-inilie d-md-none">
                        {isUahMode ? '₴' : '$'}
                    </span>
                    {!isUahMode && (
                        <span className={`fs-10 ms-2 font-bold ${dynamics > 0 ? 'text-danger' : 'text-success'}`}>
                            {dynamics > 0 ? '+' : ''}{dynamics.toFixed(2)}%
                        </span>
                    )}
                    </div>
                    
                    <div>
                    {isUahMode ? (
                        <span className="text-primary fw-bold fs-14">{t('uahMode')}</span>
                    ) : (
                        <span className="text-primary fw-bold fs-14">₴ {currentRate.toFixed(2)}</span>
                    )}
                    </div>
                </div>
                
                
            </span>
        </div>
        </>
        
    )
}

export default ToolBarRate;